import * as z from "zod";

export const maintenancePlanActionCreateSchema = z.object({
  year: z.number().int(),
  month: z.number().int().min(1).max(12),
});

export type MaintenancePlanActionCreate = z.infer<
  typeof maintenancePlanActionCreateSchema
>;
